module.exports = __webpack_public_path__ + "img/logo.158e7731.svg";